import { Typography } from "@mui/material";
import { ReactElement } from "react";

import PageContainer from "~frontend/components/PageContainer";
import { PageHeader } from "~frontend/components/PageHeader";
import { useBreadcrumbs } from "~frontend/providers/BreadcrumbsProvider";

import ShortlinksList from "./ShortlinksList";

export default function Shortlinks(): ReactElement {
  useBreadcrumbs([{ label: "Shortlinks", path: "/organization/shortlinks" }]);

  return (
    <PageContainer>
      <PageHeader isSlim>Shortlinks</PageHeader>
      <Typography variant="body1" sx={{ mb: 1 }}>
        When you have a shortlink, you'll be able to shorten links that you send
        over text and track click rates. Once you get a shortlink, you are able
        to use it for all links in your campaigns.
      </Typography>
      <Typography variant="body1" sx={{ mb: 1 }}>
        To request a shortlink click the "Request Domain" button below. After
        you submit your request, STW staff will review the request and add it to
        your account.
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Note: You are not required to use a shortlink to send links in messages.
      </Typography>
      <ShortlinksList />
    </PageContainer>
  );
}
